import { FieldTypes } from 'drapcode-constant';
import { findParentCollection } from '../collectionTraits/utils';
import { filterFieldTraitOptions } from '../dataGroup/traitsApi';
import { getCollectionFields } from '../pluginComponentApi';
import { componentRef } from './consts';

export default async function (editor, opts = {}) {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { projectId, collections } = opts;

  domc.addType(componentRef, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          icon: '<i class="wb webconnect-file-earmark-richtext"></i>',
          name: 'PDF Viewer',
          droppable: ':not(form)',
          draggable: ':not(form)',
          collectionName: '',
          projectId: projectId,
          resizable: true,
          traits: [...defaultModel.prototype.defaults.traits],
        },
        async init() {
          let collectionName = findParentCollection(this, opts);
          if (!collectionName) {
            if (opts && opts.pageCollection && opts.pageCollection.collectionId) {
              collectionName = opts.pageCollection.collectionId;
            }
          }
          if (collectionName) {
            const collectionResponse = await getCollectionFields(collectionName, collections);
            if (collectionResponse) {
              const filterTraitOptions = await filterFieldTraitOptions(collectionResponse, [
                [FieldTypes.file.id],
              ]);
              if (filterTraitOptions) {
                this.addTrait({
                  label: 'Collection Field',
                  name: 'data-pdf-viewer-field',
                  title: 'collection-field',
                  type: 'data-stripe-trait',
                  options: filterTraitOptions,
                });
              }
            }
          }
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === componentRef) {
            return {
              type: componentRef,
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
      init({ model }) {
        this.listenTo(this.model, 'change:content', this.updateContent);
        this.listenTo(model, 'change:data-pdf-viewer-field', this.updateScript);
      },
      updateContent() {
        if (this.model.get('content')) {
          this.el.innerHTML = this.model.get('content');
        }
      },
    }),
  });
}
